<div class="bcg">
    <div class="bcg container">
        <div class="d-flex justify-content-between custom-container">
            <nav class="custom-nav">
                <ol class="breadcrumb m-2">
                    <li class="breadcrumb-item" style="cursor: pointer;" (click)="gotoDashboard()">Dashboard
                    </li>
                    <li class="breadcrumb-item active" style="cursor: default;" aria-current="page">My Profile</li>
                </ol>
            </nav>
        </div>

        <!-- PERSONAL DETAILS SECTION -->
        <div class="page_responsive card mt-3">
            <div class="card-body">
                <div class="row">
                    <span class="col-6 title_five mb-2">Personal Details</span>
                </div>

                <form [formGroup]="profileDetails">
                    <div class="form_outline_sty">
                        <div class="row form_inputFields">

                            <!-- First Name -->
                            <div class="col-lg-3 col-sm-12 col-md-6 ms-3">
                                <span class="form_field">First name <span class="text-danger">*</span></span>
                                <div style="display: block">
                                    <input [(ngModel)]="firstName" class="p-2 input-field-top" pInputText type="text"
                                        placeholder="Michael" required minlength="2" maxlength="50" name="firstName"
                                        formControlName="firstName" (keypress)="sanitizeName($event)"
                                        (paste)="handlePasteEventSecure($event, 'firstName')">
                                </div>
                                <span class="p-error" style="font-size: 0.5rem;"
                                    *ngIf="submitted && profileDetails.get('firstName')?.hasError('required')">
                                    *Enter First Name
                                </span>
                            </div>

                            <!-- Last Name -->
                            <div class="col-lg-3 col-sm-12 col-md-6 ms-3">
                                <span class="form_field">Last name <span class="text-danger">*</span></span>
                                <div style="display: block">
                                    <input [(ngModel)]="lastName" class="p-2 input-field-top" pInputText type="text"
                                        placeholder="Smith" required minlength="2" maxlength="50" name="lastName"
                                        formControlName="lastName" (keypress)="sanitizeName($event)"
                                        (paste)="handlePasteEventSecure($event, 'lastName')">
                                </div>
                                <span class="p-error" style="font-size: 0.5rem;"
                                    *ngIf="submitted && profileDetails.get('lastName')?.hasError('required')">
                                    *Enter Last Name
                                </span>
                            </div>

                            <!-- Email (Read-only) -->
                            <div class="col-lg-3 col-sm-12 col-md-6 ms-3">
                                <span class="form_field" style="display: block;">Email</span>
                                <div style="display: block">
                                    <input [(ngModel)]="email" class="p-2 input-field-top" pInputText type="email"
                                        placeholder="michaelsmith@abc.com" name="email" [readOnly]="true"
                                        formControlName="email">
                                </div>
                            </div>
                        </div>

                        <div class="row form_inputFields">
                            <!-- Phone Number -->
                            <div class="col-lg-3 col-sm-12 col-md-6 ms-3">
                                <span class="form_field">Phone Number <span class="text-danger">*</span></span>
                                <div style="display: block">
                                    <input [(ngModel)]="contactNumber" class="p-2 input-field-top" type="text"
                                        pInputText placeholder="9876543210" name="contactNumber"
                                        formControlName="contact" (keypress)="numberOnlyForContact($event)"
                                        (paste)="handlePasteEventSecure($event, 'contactNumber')" maxlength="10"
                                        minlength="10" pattern="^[6-9][0-9]{9}$">
                                </div>
                                <span class="p-error" style="font-size: 0.5rem;" *ngIf="submitted && (profileDetails.get('contact')?.hasError('maxlength') || 
                         profileDetails.get('contact')?.hasError('minlength') ||
                         profileDetails.get('contact')?.hasError('pattern'))">
                                    *Enter Valid 10-digit Mobile Number starting with 6-9
                                </span>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="mt-3 custom_button text-right">
                    <p-button label="Save" (click)="savePersonalDetails()" styleClass="p-button-sm-outline"></p-button>
                </div>
            </div>

            <hr>

            <!-- ORGANIZATION DETAILS SECTION -->
            <div class="page_responsive mt-1">
                <div class="card-body">
                    <div class="row">
                        <span class="col-6 title_five mb-2">Organization Details</span>
                    </div>

                    <div class="form_outline_sty">
                        <div class="row form_inputFields">

                            <!-- Type of Organization (Read-only) -->
                            <div class="col-lg-3 col-sm-12 col-md-6 ms-3">
                                <span class="form_field">Type of Organization</span>
                                <div style="display: block">
                                    <input [(ngModel)]="organizationType" class="p-2 input-field" type="text" pInputText
                                        placeholder="Consultancy" required minlength="2" maxlength="50"
                                        name="organizationType" [readonly]="true">
                                </div>
                            </div>

                            <!-- Name of the Organization -->
                            <div class="col-lg-3 col-sm-12 col-md-6 ms-3">
                                <span class="form_field">Name of the Organization <span class="text-danger"
                                        *ngIf="editMode">*</span></span>
                                <div style="display: block">
                                    <input [(ngModel)]="organizationName" #orgNameInput="ngModel" class="p-2"
                                        [class.input-field]="!editMode" [class.input-field-edit]="editMode" type="text"
                                        pInputText placeholder="Doqfy" required minlength="2" maxlength="50"
                                        name="organizationName" [readonly]="!editMode"
                                        (keypress)="sanitizeOrganizationName($event)"
                                        (paste)="handlePasteEventSecure($event, 'organizationName')">
                                    <div *ngIf="editMode && orgNameInput.invalid && (orgNameInput.dirty || orgNameInput.touched)"
                                        class="text-danger" style="font-size: 0.75rem; margin-top: 0.25rem;">
                                        <div *ngIf="orgNameInput.errors?.['required']">Organization name is required.
                                        </div>
                                        <div *ngIf="orgNameInput.errors?.['minlength']">Minimum 2 characters required.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Phone Number -->
                            <div class="col-lg-3 col-sm-12 col-md-6 ms-3">
                                <span class="form_field">Phone Number <span class="text-danger"
                                        *ngIf="editMode">*</span></span>
                                <div style="display: block">
                                    <input [(ngModel)]="phoneNumber" #phoneInput="ngModel" class="p-2"
                                        [class.input-field]="!editMode" [class.input-field-edit]="editMode" type="text"
                                        pInputText maxlength="10" minlength="10" placeholder="9876543210" required
                                        name="phoneNumber" [readonly]="!editMode" pattern="^[6-9][0-9]{9}$"
                                        (keypress)="sanitizePhoneNumber($event)"
                                        (paste)="handlePasteEventSecure($event, 'phone')">
                                    <div *ngIf="editMode && phoneInput.invalid && (phoneInput.dirty || phoneInput.touched)"
                                        class="text-danger" style="font-size: 0.75rem; margin-top: 0.25rem;">
                                        <div *ngIf="phoneInput.errors?.['required']">Phone number is required.</div>
                                        <div *ngIf="phoneInput.errors?.['pattern'] || phoneInput.errors?.['minlength']">
                                            Phone must be 10 digits starting with 6-9.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row form_inputFields">
                            <!-- Business Email (Read-only) -->
                            <div class="col-lg-3 col-sm-12 col-md-6 ms-3">
                                <span class="form_field">Business E-mail</span>
                                <div style="display: block">
                                    <input [(ngModel)]="businessEmail" class="p-2 input-field" type="text" pInputText
                                        placeholder="abc@gmail.com" required email name="businessEmail"
                                        [readonly]="true">
                                </div>
                            </div>

                            <!-- GST -->
                            <div class="col-lg-3 col-sm-12 col-md-6 ms-3">
                                <span class="form_field me-3">GST <span class="text-danger"
                                        *ngIf="editMode">*</span></span>
                                <div style="display: block">
                                    <input [(ngModel)]="GST" #gstInput="ngModel" class="p-2"
                                        [class.input-field]="!editMode" [class.input-field-edit]="editMode" type="text"
                                        placeholder="22AAAAA0000A1Z5" pInputText required name="GST"
                                        [readonly]="!editMode" maxlength="15" minlength="15"
                                        (keypress)="sanitizeGST($event)" (input)="onGSTInput($event)"
                                        (paste)="handlePasteEventSecure($event, 'GST')">
                                    <div *ngIf="editMode && gstInput.invalid && (gstInput.dirty || gstInput.touched)"
                                        class="text-danger" style="font-size: 0.75rem; margin-top: 0.25rem;">
                                        <div *ngIf="gstInput.errors?.['required']">GST number is required.</div>
                                        <div *ngIf="gstInput.errors?.['minlength']">GST must be exactly 15 characters.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- PAN -->
                            <div class="col-lg-3 col-sm-12 col-md-6 ms-3">
                                <span class="form_field me-3">PAN <span class="text-danger"
                                        *ngIf="editMode">*</span></span>
                                <div style="display: block">
                                    <input [(ngModel)]="PAN" #panInput="ngModel" class="p-2"
                                        [class.input-field]="!editMode" [class.input-field-edit]="editMode" type="text"
                                        placeholder="ABCDE1234F" pInputText required name="PAN" [readonly]="!editMode"
                                        pattern="[A-Z]{5}[0-9]{4}[A-Z]" maxlength="10" (keypress)="sanitizePAN($event)"
                                        (input)="onPANInput($event)" (paste)="handlePasteEventSecure($event, 'PAN')">
                                    <div *ngIf="editMode && panInput.invalid && (panInput.dirty || panInput.touched)"
                                        class="text-danger" style="font-size: 0.75rem; margin-top: 0.25rem;">
                                        <div *ngIf="panInput.errors?.['required']">PAN number is required.</div>
                                        <div *ngIf="panInput.errors?.['pattern']">
                                            Invalid PAN. Must be 5 letters, 4 digits, 1 letter (e.g., ABCDE1234F).
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row form_inputFields">
                            <!-- Address -->
                            <div class="col-lg-3 col-sm-12 col-md-6 ms-3">
                                <span class="form_field me-3">Address <span class="text-danger"
                                        *ngIf="editMode">*</span></span>
                                <div style="display: block">
                                    <textarea [(ngModel)]="address" #addressInput="ngModel" class="p-2" type="text"
                                        [class.input-field]="!editMode" [class.input-field-edit]="editMode"
                                        placeholder="Enter complete address" pInputText required name="address"
                                        style="height: 4rem;" [readonly]="!editMode" maxlength="200"
                                        (keypress)="sanitizeAddress($event)"
                                        (paste)="handlePasteEventSecure($event, 'address')"></textarea>
                                    <div *ngIf="editMode && addressInput.invalid && (addressInput.dirty || addressInput.touched)"
                                        class="text-danger" style="font-size: 0.75rem; margin-top: 0.25rem;">
                                        <div *ngIf="addressInput.errors?.['required']">Address is required.</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Billing Type (Read-only) -->
                            <div class="col-lg-3 col-sm-12 col-md-6 ms-3">
                                <span class="form_field me-3">Billing Type</span>
                                <div style="display: block">
                                    <input [(ngModel)]="billingType" class="p-2 input-field" type="text" pInputText
                                        placeholder="Billing Type" name="billingType" [readonly]="true">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Edit/Save Buttons -->
                    <div *ngIf="editMode" class="mt-3 custom_button text-right">
                        <p-button label="Cancel" (click)="cancelEdit()" styleClass="p-button-sm me-3"></p-button>
                        <p-button label="Save" (click)="SaveOrganizationData()"
                            styleClass="p-button-sm-outline"></p-button>
                    </div>

                    <div *ngIf="showEditMode" class="mt-3 custom_button text-right">
                        <p-button label="Edit" (click)="editOrganization()" styleClass="p-button-sm-outline"></p-button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Toast Message Display -->
    <div class="toast_display_layer">
        <p-toast></p-toast>
    </div>
</div>